@if (mediaQueryService.breakpoints$ | async; as breakpoints) {
  <div [ngClass]="{ edit: editMode }" class="labeled-edit-container" data-test-id="labeled-edit-container">
    @if (!editMode) {
      <div class="labeled-edit-label">
        {{ label }}
        <tooltip-popover #tooltip position="bottom">
          @if (tooltipHtml) {
            <mat-icon-with-hover
              #tooltipIcon
              iconName="tooltip_default"
              iconNameActive="tooltip_active"
              iconNameHover="tooltip_hover"
            ></mat-icon-with-hover>
          }
          <ng-template #tooltipPopoverContent="cdkPortal" cdkPortal let-tooltipPopover>
            <mat-icon (click)="tooltip.closePopover()" class="close-icon" svgIcon="close_tiny"></mat-icon>
            <div [innerHTML]="tooltipHtml" [ngClass]="multilineTooltip ? 'multiline-content' : 'tooltip-content'"></div>
          </ng-template>
        </tooltip-popover>
      </div>
    }

    @if (!editMode) {
      <div class="labeled-edit-content flex flex-between-stretch" data-test-id="labeled-edit-content">
        @if (fieldValue && display === 'text') {
          <span class="labeled-edit-value">{{ fieldValue }}</span>
        }
        @if (!fieldValue) {
          <span class="labeled-edit-value placeholder">{{ placeholder }}</span>
        }

        @if (display === 'url') {
          <a [attr.href]="getContactWebsite()" class="labeled-edit-value" target="_blank">{{ fieldValue }}</a>
        }
        @if (display === 'skype') {
          <a [attr.href]="getSkype()" class="labeled-edit-value">{{ fieldValue }}</a>
        }

        @if (!readonly && canEdit) {
          @if (!fieldValue) {
            <button
              (click)="activate()"
              class="small-button"
              color="primary"
              data-test-id="labeled-edit-add-button"
              mat-button
            >
              Add
            </button>
          }
          @if (fieldValue) {
            <button
              (click)="activate()"
              class="small-button"
              color="primary"
              data-test-id="labeled-edit-edit-button"
              mat-button
            >
              Edit
            </button>
          }
        }
      </div>
    }

    @if (editMode) {
      <form
        [formGroup]="labeledEditForm"
        [ngClass]="{ loading: loading }"
        (keydown)="keyListener($event)"
        (keypress)="keyListener($event)"
        (ngSubmit)="update()"
        class="edit-form"
        data-test-id="labeled-edit-form"
        name="labeledEditForm"
        novalidate
      >
        <h4 class="font-bold">Edit {{ label }}</h4>
        <div class="content">
          <mat-form-field appearance="outline" floatLabel="always" subscriptSizing="dynamic">
            <mat-label>{{ label }}</mat-label>
            <input
              [attr.maxlength]="maxlength"
              #inputEl
              data-test-id="labeled-edit-input"
              formControlName="fieldValue"
              matInput
              name="labeledEditInput"
              placeholder="{{ placeholder }}"
              type="{{ type }}"
            />
          </mat-form-field>
          <validation-messages
            [field]="labeledEditForm.get('fieldValue')"
            [messages]="['required', 'urlNotValid', 'emailNotValid', 'maxlength']"
            [texts]="{
              required: 'Field is required!',
              urlNotValid: 'Provided URL is not valid',
              emailNotValid: 'Provided e-mail is not valid',
            }"
            data-test-id="labeled-edit-input-validation-message"
          ></validation-messages>
        </div>
        <div class="action-bar flex flex-wrap">
          <button
            [loading]="loading"
            class="small-button save-button"
            color="primary"
            data-test-id="labeled-edit-save-button"
            mat-stroked-button
            type="submit"
          >
            {{
              breakpoints.ltMd ? COMMON_BUTTONS_TEXTS.SAVE_CHANGES_MOBILE : COMMON_BUTTONS_TEXTS.SAVE_CHANGES_DESKTOP
            }}
          </button>
          <button
            (click)="reset()"
            class="small-button cancel-button"
            color="primary"
            data-test-id="labeled-edit-discard-button"
            mat-button
            type="button"
          >
            {{
              breakpoints.ltMd
                ? COMMON_BUTTONS_TEXTS.DISCARD_CHANGES_MOBILE
                : COMMON_BUTTONS_TEXTS.DISCARD_CHANGES_DESKTOP
            }}
          </button>
        </div>
      </form>
    }
  </div>
}
